import { createAction, props, Action } from '@ngrx/store';
import { Etl } from '@models';
import { errorTypes } from '@etl/etl.reducer';
import { ICompany } from '@company/company.structures';

export const create = createAction(
  '[Etl Component] create',
  props<{row: Etl}>()
);

export const remove = createAction(
  '[Etl Component] remove',
  props<{row: Etl}>()
);

export const getCollection = createAction('[Etl Component] getCollection');

export const getCompanyJobs = createAction(
  '[Etl Component] getCompanyJobs',
  props<{companyId: number}>()
);

export const rowWasDeleted = createAction(
  '[Etl Component] rowWasDeleted',
  props<{row: Etl}>()
);

export const collectionLoaded = createAction(
  '[Etl Component] collectionLoaded',
  props<{newCollection: Etl[]}>()
);

export const rowAdded = createAction(
  '[Etl Component] rowAdded',
  props<{row: Etl}>()
);

export const failRequest = createAction(
  '[Etl Component] failRequest',
  props<{error: any, errorType: errorTypes}>()
);

export const update = createAction(
  '[Etl Component] update',
  props<{row: Etl}>()
);

export const rowEdited = createAction(
  '[Etl Component] row Edited',
  props<{row: Etl}>()
);

export const resetParams = createAction(
  '[Etl Component] reset params',
  props<{row: Etl}>()
);

export const setRow = createAction(
  '[Etl Component] set row',
  props<{row: Etl}>()
);

export const startAction = createAction(
  '[Etl Component] start action',
  props<{row: Etl}>()
);

export const startActionSuccess = createAction(
  '[Etl Component] start action success',
  props<{row: Etl}>()
);

export const jobDetails = createAction(
  '[Etl Component] jobDetails',
  props<{row: Etl}>()
);
export const jobDetailsLoaded = createAction(
  '[Etl Component] jobDetailsLoaded',
  props<{row: Etl, finished: boolean}>()
);
